export const tooltipTrackingMessage = {
  Date: 'Number of days added to the current date when inventory is received',
  Text: 'Indicates what the next lot number will be when added to inventory',
  'Serial Number':
    'Indicates what the next serial number will be when added to inventory',
};

export const decimalQuantitiesValidationMessage =
  'Cannot enable serial tracking when inventory on hand includes decimal quantities.';
